module.exports = __webpack_public_path__ + "static/img/teamfight_tactics.3a5b831.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/teamfight_tactics.jpg
// module id = csTs
// module chunks = 35